<template>
    <div class="row position-relative" style="margin-top: 55px;">
        <div class="bg-computer">
            <div class="row container my-5 py-3">
                <div class="col-2"></div>
                <div class="col-md-5 text-end pe-5">
                    <h3 class="fw-bold my-4">خدمات سازمانی هوش مصنوعی، داده و فناوری‌های نوین</h3>
                    <!-- <h5 class="fw-bold my-4">خدمات متنوع و تخصصی بازار ارزهای دیجیتال</h5>
                    <h6 class="my-4">با استفاده از بروز ترین خدمات حداکثر بازدهی را تجربه کنید</h6> -->
                    <button class="btn-blue mt-5">ثبت نام رایگان</button>
                </div>
                <div class="col-md-5 text-start">
                    <img src="../../assets/services-img/computer.png" width="85%" alt="">
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="row col-lg-9 mx-auto">
            <div class="my-5">
                <div class="row px-0 mx-0 mt-5 pt-5">
                    <h3 class="fw-bold">خدمات سازمانی</h3>
                    <h5 class="mt-3 ps-3" style="line-height: 30px;">
                        در دنیای رقابتی امروز، سازمان‌ها برای حفظ مزیت رقابتی و افزایش بهره‌وری نیازمند استفاده از فناوری‌های نوین هستند. ما در شرکت خود، با تکیه بر دانش فنی و مهندسی پیشرفته، راهکارهای نوآورانه‌ای در زمینه هوش مصنوعی، مهندسی داده، بلاکچین، اینترنت اشیا و دیگر فناوری‌های تحول‌آفرین ارائه می‌دهیم. خدمات سازمانی ما به شما کمک می‌کند تا فرآیندهای کاری خود را بهینه کنید، تصمیم‌گیری‌های هوشمندانه‌تری داشته باشید و کسب‌وکار خود را به سمت آینده‌ای دیجیتال هدایت کنید.
                    </h5>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="text-end">
                        <h4 class="fw-bold">نیازهای سازمان‌ها و چالش‌های موجود</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>
                                    <strong>عدم بهره‌وری بهینه از داده‌ها:</strong>
                                    بسیاری از سازمان‌ها داده‌های ارزشمندی دارند اما نمی‌توانند از آن‌ها برای تصمیم‌گیری‌های استراتژیک استفاده کنند.
                                </li>
                                <li class="mt-3">
                                    <strong>چالش در پیاده‌سازی فناوری‌های نوین:</strong>
                                    ورود به حوزه‌هایی مانند هوش مصنوعی و بلاکچین بدون راهکارهای مناسب می‌تواند پیچیدگی‌های بسیاری ایجاد کند.
                                </li>
                                <li class="mt-3">
                                    <strong>افزایش هزینه‌ها و کاهش کارایی:</strong>
                                    سازمان‌هایی که از روش‌های سنتی استفاده می‌کنند، معمولاً با هزینه‌های اضافی و بهره‌وری پایین مواجه هستند.
                                </li>
                                <li class="mt-3">
                                    <strong>نیاز به مدیریت هوشمند منابع و فرآیندها:</strong>
                                    سازمان‌ها به دنبال راه‌هایی برای بهینه‌سازی مدیریت منابع، کاهش هزینه‌ها و افزایش کارایی هستند.
                                </li>
                            </ul>
                        </h6>
                    </div>
                </div>
            </div>
            <div class="my-5">
                <h3 class="fw-bold">راهکارهای ما برای سازمان‌ها</h3>
                <h6>ما خدمات جامعی را برای سازمان‌ها ارائه می‌دهیم که شامل موارد زیر است:</h6>
                <div class="row px-0 mx-0 mt-5">
                    <div class="col-md-7 text-end">
                        <h4 class="fw-bold mt-5">استقرار و پیاده‌سازی هوش مصنوعی در سازمان‌ها</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>تحلیل و پردازش داده‌های سازمانی برای تصمیم‌گیری بهتر</li>
                                <li>پیاده‌سازی مدل‌های یادگیری ماشین برای پیش‌بینی روندهای کسب‌وکار</li>
                                <li>هوشمندسازی فرآیندهای داخلی و افزایش اتوماسیون سازمانی</li>
                            </ul>
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/img1.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../assets/services-img/img2.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5">مهندسی داده و مدیریت داده‌های سازمانی</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>طراحی و پیاده‌سازی زیرساخت‌های داده‌ای مقیاس‌پذیر</li>
                                <li>پردازش و تجزیه و تحلیل داده‌های کلان (Big Data)</li>
                                <li>راهکارهای مدیریت داده‌های سازمانی برای افزایش امنیت و دسترس‌پذیری</li>
                            </ul>    
                        </h6>
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5"> راهکارهای بلاکچین برای امنیت و شفافیت سازمانی</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>پیاده‌سازی قراردادهای هوشمند برای خودکارسازی فرآیندها</li>
                                <li>افزایش امنیت داده‌ها و کاهش خطرات تقلب و دستکاری اطلاعات</li>
                                <li>ایجاد سیستم‌های غیرمتمرکز برای مدیریت داده‌ها</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/img3.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../assets/services-img/img4.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5">اینترنت اشیا (IoT) برای بهینه‌سازی عملیات سازمانی</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>اتصال و یکپارچه‌سازی تجهیزات سازمانی برای افزایش بهره‌وری</li>
                                <li>مانیتورینگ هوشمند دارایی‌ها و فرآیندهای کسب‌وکار</li>
                                <li>تحلیل داده‌های حسگرها برای بهبود عملکرد سیستم‌ها</li>
                            </ul>  
                        </h6>
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5"> راهکارهای هوشمند مدیریت منابع انسانی و اتوماسیون اداری</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>سیستم‌های تحلیل عملکرد کارکنان و پیش‌بینی رفتار آن‌ها</li>
                                <li>پیاده‌سازی ابزارهای اتوماسیون برای بهبود بهره‌وری سازمانی</li>
                                <li>استفاده از الگوریتم‌های یادگیری ماشین برای بهینه‌سازی استخدام و آموزش کارکنان</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/img5.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-5 my-auto text-end">
                        <img src="../../assets/services-img/img6.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5"> مشاوره و استراتژی تحول دیجیتال</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>تحلیل وضعیت فعلی سازمان و ارائه نقشه راه دیجیتالی‌سازی</li>
                                <li>تدوین استراتژی‌های فناوری برای افزایش بهره‌وری و سودآوری</li>
                                <li>آموزش و توانمندسازی مدیران و کارکنان در حوزه فناوری‌های نوین</li>
                            </ul>  
                        </h6>
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5"> مدیریت امنیت سایبری و حفاظت از داده‌ها</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>ارزیابی امنیتی زیرساخت‌های سازمانی و کاهش تهدیدهای سایبری</li>
                                <li>اجرای راهکارهای رمزنگاری و کنترل دسترسی برای حفاظت از داده‌ها</li>
                                <li>ایجاد پروتکل‌های امنیتی برای مقابله با حملات سایبری</li>
                            </ul>  
                        </h6>
                    </div>
                    <div class="col-md-5 my-auto text-start">
                        <img src="../../assets/services-img/img7.svg" class="w-100" alt="">
                    </div>
                </div>
            </div>
            <div class="my-5">
                <div class="row px-0 mx-0">
                    <div class="col-lg-5 my-auto text-end">
                        <img src="../../assets/services-img/img8.svg" class="w-100" alt="">
                    </div>
                    <div class="col-md-7 text-end mt-5">
                        <h4 class="fw-bold mt-5">  توسعه نرم‌افزارهای سازمانی و سفارشی‌سازی سیستم‌ها</h4>
                        <h6 class="mt-3 ps-3" style="line-height: 30px;">
                            <ul>
                                <li>طراحی و پیاده‌سازی نرم‌افزارهای سازمانی بر اساس نیازهای کسب‌وکار</li>
                                <li>بهینه‌سازی و سفارشی‌سازی سیستم‌های مدیریت منابع سازمانی (ERP)</li>
                                <li>یکپارچه‌سازی نرم‌افزارهای قدیمی با فناوری‌های مدرن</li>
                            </ul>  
                        </h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="row position-relative">
        <div class="bg-computer" style="border-top-right-radius: 40px;">
            <div class="container my-5 py-3">
                <h2 class="my-5 text-end">نتایج و ارزش‌آفرینی برای سازمان‌ها</h2>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/fast.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>افزایش سرعت و دقت در تصمیم‌گیری‌ها</strong> از طریق استفاده از هوش مصنوعی و تحلیل داده 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/Product.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>کاهش هزینه‌های عملیاتی و افزایش بهره‌وری</strong> با پیاده‌سازی فناوری‌های هوشمند 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-lg-flex d-none">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/Secure.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>افزایش امنیت اطلاعات و شفافیت در فرآیندها</strong> با بهره‌گیری از بلاکچین و مدیریت داده 
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-3 col-md-6 d-lg-none d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/Secure.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>افزایش امنیت اطلاعات و شفافیت در فرآیندها</strong> با بهره‌گیری از بلاکچین و مدیریت داده 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/Business.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>بهینه‌سازی فرآیندهای سازمانی</strong> از طریق خودکارسازی و کاهش مداخله‌های انسانی 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/Organizing.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>بهبود مدیریت و نظارت بر عملیات سازمانی</strong> با استفاده از اینترنت اشیا و داده‌های بلادرنگ 
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-3 col-md-6 d-flex">
                        <div class="card-hover">
                            <div>
                                <img src="../../assets/services-img/Online report.svg" class="w-75" alt="">
                            </div>
                            <div class="mt-3 ps-3" style="line-height: 30px;font-size: 14px;">
                                <strong>افزایش نوآوری و تحول دیجیتال</strong> از طریق مشاوره تخصصی و پیاده‌سازی فناوری‌های نوین 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section class="container py-3">
        <div class="row col-md-9 mx-auto mt-5">
            <h3>سوالات متداول</h3>
            <div class="mx-auto my-5">
              <div class="accordion accordion-flush" id="accordionExample">
                <!-- 1: coll1 -->
                <div class="accordion-item">
                  <h2 class="accordion-header text-end">
                    <!--   data-bs-target="#coll1",  controls="coll1", id="coll1", aria-expanded="true"      -->
                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#coll1" aria-expanded="true" aria-controls="coll1">
                      <h6>چگونه می‌توانم از خدمات سازمانی شما استفاده کنم؟</h6>
                    </button>
                  </h2>
                  <!-- show : by default Always open -->
                  <div id="coll1" class="accordion-collapse collapse show text-end" data-bs-parent="#accordionExample">
                    <div class="accordion-body text-end" style="line-height: 35px !important;">
                        شما می‌توانید از طریق تماس با تیم مشاوره ما، نیازهای خود را مطرح کنید. سپس کارشناسان ما یک تحلیل دقیق انجام داده و راهکار مناسب را ارائه خواهند داد.
                    </div>
                  </div>
                </div>

                <!-- 2: coll2 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--       collapsed,   aria-expanded="false"   -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll2" aria-expanded="false" aria-controls="coll2">
                      <h6>آیا خدمات شما برای سازمان‌های کوچک هم مناسب است؟</h6>
                    </button>
                  </h2>
                  <div id="coll2" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        بله، ما راهکارهای خود را متناسب با اندازه و نیازهای هر سازمان طراحی می‌کنیم، چه سازمان‌های بزرگ و چه کسب‌وکارهای کوچک و متوسط.
                    </div>
                  </div>
                </div>

                <!-- 3: coll3 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll3" aria-expanded="false" aria-controls="coll3">
                      <h6> امنیت داده‌های سازمانی چگونه تضمین می‌شود؟</h6>
                    </button>
                  </h2>
                  <div id="coll3" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        امنیت داده‌های سازمانی چگونه تضمین می‌شود؟
                    </div>
                  </div>
                </div>

                <!-- 4: coll4 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll4",  id="coll4"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll4" aria-expanded="false" aria-controls="coll4">
                      <h6>آیا خدمات شما سفارشی‌سازی می‌شوند؟</h6>
                    </button>
                  </h2>
                  <div id="coll4" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        بله، ما راهکارهای خود را متناسب با نیازهای خاص هر سازمان طراحی و پیاده‌سازی می‌کنیم تا بیشترین ارزش را برای مشتریان خود ایجاد کنیم.
                    </div>
                  </div>
                </div>

                <!-- 5: coll5 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll5",  id="coll5"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll5" aria-expanded="false" aria-controls="coll5">
                      <h6>آیا تیم شما آموزش‌های لازم را به کارکنان سازمان ارائه می‌دهد؟</h6>
                    </button>
                  </h2>
                  <div id="coll5" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                        بله، ما علاوه بر پیاده‌سازی راهکارها، آموزش‌های کاملی را نیز برای کارکنان سازمان ارائه می‌دهیم تا بتوانند از فناوری‌های جدید به بهترین شکل استفاده کنند.
                        <br>
                        ما به عنوان یک شرکت راهکار محور، به سازمان‌ها کمک می‌کنیم تا با استفاده از فناوری‌های نوین، گام‌های مؤثری در جهت توسعه و تحول دیجیتال بردارند. جهت دریافت مشاوره و اطلاعات بیشتر، با ما در تماس باشید.
                    </div>
                  </div>
                </div>

                <!-- 6: coll6 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll6",  id="coll6"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll6" aria-expanded="false" aria-controls="coll6">
                      <h6>آیا پیش‌بینی‌ها در ناباکو قابل توضیح هستند؟</h6>
                    </button>
                  </h2>
                  <div id="coll6" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                      ما بر این باوریم که قابلیت توضیح مدل‌های یادگیری ماشین به همان اندازه که عملکرد آنها در بسیاری از کاربردهای تجاری اهمیت دارد، به دلایل مختلفی مانند اعتماد، مقررات، جنبه‌های فنی و اخلاقی اهمیت دارد. پلتفرم هوش مصنوعی ما از تکنیک SHAP (توضیحات افزایشی شاپلی) پشتیبانی می‌کند که هر پیش‌بینی را به سهم متغیرهای ورودی فردی تجزیه می‌کند. سهم هر متغیر ورودی (مثبت یا منفی) قابل محاسبه است و مجموع این سهم‌ها پیش‌بینی مدل را فراهم می‌کند. این رویکرد به ما این امکان را می‌دهد که یک پیش‌بینی را با استفاده از تعداد کمی از دسته‌های ویژگی توضیح دهیم و از افزایشی بودن مقادیر SHAP بهره‌برداری کنیم.
                    </div>
                  </div>
                </div>

                <!-- 7: coll7 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll7",  id="coll7"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll7" aria-expanded="false" aria-controls="coll7">
                      <h6> هوش مصنوعی قابل توضیح و انتخاب ویژگی‌ها</h6>
                    </button>
                  </h2>
                  <div id="coll7" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                      فناوری ناباکو از روش MDA مبتنی بر خوشه‌بندی برای رتبه‌بندی و انتخاب اهمیت ویژگی‌ها استفاده می‌کند. این رویکرد به‌دلیل ارائه نتایج قابل توضیح و پایدارترین برای کاربران ما انتخاب شده است.
                    </div>
                  </div>
                </div>

                <!-- 8: coll8 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll8",  id="coll8"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll8" aria-expanded="false" aria-controls="coll8">
                      <h6>بهینه‌سازی پورتفولیو شرطی</h6>
                    </button>
                  </h2>
                  <div id="coll8" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                      فناوری ناباکو از روش MDA مبتنی بر خوشه‌بندی برای رتبه‌بندی و انتخاب اهمیت ویژگی‌ها استفاده می‌کند. این رویکرد به‌دلیل ارائه نتایج قابل توضیح و پایدارترین برای کاربران ما انتخاب شده است.
                    </div>
                  </div>
                </div>

                <!-- 9: coll9 -->
                <div class="accordion-item">
                  <h2 class="accordion-header">
                    <!--   target="#coll9",  id="coll9"  -->
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#coll9" aria-expanded="false" aria-controls="coll9">
                      <h6>مدیریت ریسک از طریق هوش مصنوعی اصلاحی</h6>
                    </button>
                  </h2>
                  <div id="coll9" class="accordion-collapse collapse" data-bs-parent="#accordionExample">
                    <div class="accordion-body" style="line-height: 35px !important;">
                      نرم‌افزار ناباکو از مدل‌های یادگیری ماشین برای ارزیابی احتمال سود برای معاملات، همچنین تخصیص سرمایه و مدیریت ریسک‌ها استفاده می‌کند. این رویکرد کمّی-اساسی به مدیران سرمایه‌گذاری اختیاری یا بنیادی کمک می‌کند تا استراتژی‌ها و بینش‌های خود را به‌صورت کمی و سیستماتیک کرده و بدون نیاز به افشای استراتژی زیرین به مشاور، از آن بهره‌برداری کنند.
                    </div>
                  </div>
                </div>

              </div>
            </div>

        </div>
    </section>
</template>
<script>
import { defineComponent } from 'vue';
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSlash } from "@fortawesome/free-solid-svg-icons";

 export default defineComponent({
    components:{},
    setup() {
        library.add(faSlash)

        return {

        }
    }
 })
</script>
<style lang="scss" scoped>
.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-button:not(.collapsed) {
  /* background-color: #c5e5d8;*/
  background-color: #f7f7f7;
}

.accordion-button:not(.collapsed)::after {
  background-image: none;
  transform: none;
}

.accordion-button:focus {
  box-shadow: none;
  z-index: 1;
}

.accordion-button:before {
  content: "";
  position: absolute;
  /*   right: 0.75rem; */
  left: 0.75rem;
  top: 1.25rem;
  height: 2px;
  width: 1rem;
  background-color: #1838D2;
}
.accordion-button.collapsed:after {
  content: "";
  position: absolute;
  /*   right: 1.1875rem; */
  left: 1.1875rem;
  top: 0.8125rem;
  height: 1.0625rem;
  width: 0.125rem;
  border-style: none;
  background-color: #1838D2;
}

.faq-section .accordion-button h5 {
  /*   color: #7dbc9e; */
  color: #1838D2;
  margin-right: 13px;
}
.accordion-body {
  background-color: #f7f7f7;
  font-size: 14px !important;
  padding-left: 50px;
  padding-right: 30px;
  text-align: justify;
}
</style>